import { Injectable, signal } from '@angular/core';
import { BusinessAccount } from '@/app/common/general-types/business-account.dto';

@Injectable({ providedIn: 'root' })
export class BrandInsightsState {
  readonly brand = signal<BusinessAccount | undefined>(undefined);

  setBrand(brand: BusinessAccount | undefined): void {
    this.brand.set(brand);
  }

  patchBrand(account: BusinessAccount): void {
    this.brand.update((prev) => {
      if (!prev || prev.id === account.id) {
        return { ...(prev ?? account), ...account };
      }
      return prev;
    });
  }
}
